import { useAppDispatch, useAppSelector } from '../../../redux/hooks';
import { selectModalData } from '../../../redux/selectors/modal';
import { closeModal } from '../../../redux/slices/modal';
import ConfirmationModal from '../../ConfirmationModal';
import { useScratchpadContext } from '../ScratchpadContext';

const DeleteScratchpadModal = () => {
  const dispatch = useAppDispatch();
  const data = useAppSelector(selectModalData);
  const { scratchpadId } = data;
  const { deleteScratchpad } = useScratchpadContext();

  const handleSubmit = () => {
    deleteScratchpad(scratchpadId);
    dispatch(closeModal());
  };

  const handleClose = () => {
    dispatch(closeModal());
  };

  return (
    <ConfirmationModal
      open={true}
      header="Delete Scratchpad"
      onSubmit={handleSubmit}
      onClose={handleClose}
      confirmActionLabel="Delete"
      modalType="danger"
      trackContext="scratchpad"
      trackConfirmAction="delete-scratchpad-confirm"
      trackCancelAction="delete-scratchpad-cancel"
    >
      Are you sure you want to delete this scratchpad? This action cannot be
      undone.
    </ConfirmationModal>
  );
};

export default DeleteScratchpadModal;
